import React, { Component } from "react";

import RadioButtonDistributionCode from './RadioButtonDistributionCode.jsx';
import EditarTarjeta from './EditarTarjeta.jsx';
import SeleccionarTarjeta from './SeleccionarTarjeta.jsx';
import Dias from './Dias.jsx';
import TipoTarjeta from './TipoTarjeta.jsx';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';
import { CodigoDistribucion } from "./controles/CodigoDistribucion.jsx"
import { runInDebugContext } from "vm";

let days;
let titularCard;
let kindCard;

class InputComplete extends Component {
    constructor(props) {
        super(props);
        this.validateAddCard = this.validateAddCard.bind(this);
    }

    validateAddCard() {
        this.props.validateAddCard(this.props.data, this.props.form);
    }

    changeLimit(event) {
        if (event.target.value <= 100) {
            this.props.getLimit(event.target.value);
        }
    }

    changeDenomination(event) {
        if (event.target.validity.valid) {
            this.props.getDenomination(event.target.value);
        }
    }

    changeDenominationalphaOnly(event) {
        this.props.validateAlphaOnly(event.target.value, event.target.validity.valid);
    }

    validateAndGetLimit(event) {
        let valor = event.target.value;
        if (valor == "" || valor == ".") {
            this.props.getLimit(0);
        } else {
            if (/^((\d{0,2})(\.(\d{0,2}))?)$/g.test(valor)) {
                let asdas = valor.substring(valor.length - 1, valor.length);
                if (asdas == ".") {
                    this.props.getLimit(valor);
                } else {
                    let num = GlobalHelper.ParseFloat(valor);
                    this.props.getLimit(num);
                }
                
            }
        }
    }

    render() {

        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorDenominacion;
        let errorLimite = undefined;

        if (this.props.data.titularCard != undefined || this.props.data.tarjetaCreada) {
            errorDenominacion = <label className="error">
                {(errors = getFieldError('denominacionTarjeta')) ?
                    this.props.form.isFieldTouched("denominacionTarjeta") ?
                        errors.join(',') : null
                    : null}</label>
        } else {
            errorDenominacion = <label className="error">
                {(errors = getFieldError('denominacionTarjeta')) ? errors.join(',') : null}</label>
        }

        if (this.props.data.limiteCreado) {
            errorLimite = <label className="error">
                {(errors = getFieldError('limiteCompra')) ? errors.join(',') : null}</label>
        }
        else {
            errorLimite = <label className="error">
                {(errors = getFieldError('limiteCompra')) ?
                    this.props.form.isFieldTouched("limiteCompra") ?
                        errors.join(',') : null
                    : null}</label>
        }

        let disabledBotonNuevaTarjetaProp = { disabled: "disabled" };

        if (this.props.data.permisos.components.BotonNuevaTarjeta.Locked == false) {
            delete disabledBotonNuevaTarjetaProp.disabled;
        }

        let cuentaSeleccionada = this.props.data.cuentas.find(x => x.seleccionada == true);
        let limiteCompra = this.props.data.valor;
        let limiteCuenta = cuentaSeleccionada.Valor !== undefined ? cuentaSeleccionada.Valor : cuentaSeleccionada.limit;
        let limiteCuentaFormato = GlobalHelper.ConvertirNumeroSinDecimales(limiteCuenta);
        let textoEstado = this.props.data.estado;
        let trick = this.props.data.modalidadDistribucionLimiteIdEncuentaSeleccionada;
        let limiteCompraInput = null;
        //let limiteCompraFormato = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompra);
        let limiteCompraFormato = GlobalHelper.ParseFloat(limiteCompra);

        if (this.props.data != undefined && this.props.data.headline != undefined) {
            titularCard = <EditarTarjeta edit={this.props.data}
                changeToSelectCard={this.props.changeToSelectCard} />
        }
        else {
            titularCard = <SeleccionarTarjeta data={this.props.data} getHeadline={this.props.getHeadline} />
        }

        if (this.props.data != undefined && this.props.data.checkTempCard) {
            days = <Dias data={this.props.data} getDays={this.props.getDays} />
        }
        else {
            days = undefined;
        }

        kindCard = <TipoTarjeta data={this.props.data} getKind={this.props.getKind} />
        let minValueLimite = GlobalHelper.ConvertirNumeroSinDecimales(this.props.data.minValueLimite);
        if (trick > 1) {
            limiteCompraInput = <div className="top-separator-xs">
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Límite de Compra&nbsp;</label><label className="label-secondary"> (% del límite de la cuenta)</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2">
                        <input value={this.props.data.limite} className="form-control default-input" onChange={(event) => { this.validateAndGetLimit(event); }}
                        />

                        {this.props.data.ERROR_CARD["limiteCompra"] == false
                            ? <label className="error">Debe ingresar un límite de compra</label> : null}
                    </div>
                    <div className="col-xs-10">
                        <div className="row">
                            <div className="col-xs-12">
                                {this.props.data.ERROR_CARD["limiteSuperado"] == true
                                    ? <label className="error">Ha excedido el limite de compra</label>
                                    : null}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                {this.props.data.ERROR_CARD["limiteValido"] == true
                                    ? <label className="error">El límite no puede ser inferior al mínimo (${minValueLimite})</label>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <h6>$ {limiteCompraFormato} de $ {limiteCuentaFormato}</h6>
                    </div>
                </div>
            </div>
        }

        let denominacion = this.props.data.denomination == "" || this.props.data.denomination == undefined ? "" : this.props.data.denomination.substring(0, 19)
        let denominacionTarjeta = this.props.data.denominationCard == "" || this.props.data.denominationCard == undefined ? this.props.data.denominationCard : this.props.data.denominationCard.substring(0, 19)

        return (
            <div className="col-xs-12">
                <div className="top-separator-xs">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Titular de la tarjeta</label>
                        </div>
                    </div>
                    <div className="row">
                        {titularCard}
                    </div>
                </div>
                <div className="top-separator-xs">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Denominación de la tarjeta</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">
                            <GenericInputValidate
                                getFieldProps={getFieldProps('denominacionTarjeta', {
                                    onChange(e) {
                                        me.changeDenominationalphaOnly(e);
                                    },
                                    rules: [{
                                        required: true,
                                        message: 'Debe ingresar la denominación de la tarjeta.'
                                    }]
                                })}
                                id="denominacionTarjeta"
                                name="denominacionTarjeta"
                                value={denominacionTarjeta}
                                maxLength="19"
                                className="form-control default-input"
                            />
                            {errorDenominacion}
                        </div>
                        <div className="col-xs-8">

                        </div>
                    </div>
                </div>
                <div className="top-separator-xs">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Denominación 4ª línea (opcional)</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">
                            <input type="text" className="form-control default-input"
                                value={denominacion}
                                onChange={(event) => this.changeDenomination(event)}
                                maxLength="19"
                            ></input>
                        </div>
                        <div className="col-xs-8"></div>
                    </div>
                </div>
                <div className="top-separator-xs">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Tipo de tarjeta</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-4">
                            {kindCard}
                        </div>
                        <div className="col-xs-8"></div>
                    </div>
                </div>
                <div className="top-separator-xs">
                    <div className="row">
                        <div className="col-md-4">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                    <div className="default-checkbox">
                                        <input type="checkbox" id="chkTemp" checked={this.props.data.checkTempCard} onChange={this.props.openDays} ></input>
                                        <label className="label-primary" htmlFor="chkTemp"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkTemp">Es una tarjeta temporal</label>
                                </li>
                            </ul>
                        </div>
                        {days}
                        <div className="col-md-6"></div>
                    </div>
                </div>
                {limiteCompraInput}

                <CodigoDistribucion data={this.props.data}
                    codigoDistribucion={this.props.data.codigoDistribucion}
                    codigosDistribucion={this.props.data.codigosDistribucion}
                    seleccionarCodigoDistribucion={this.props.seleccionarCodigoDistribucion} />

                <div className="top-separator-xs bottom-separator-xs">
                    <div className="row">
                        {(this.props.data.permisos.components.BotonNuevaTarjeta.Active == true) &&
                            <div className="col-xs-12">
                                <GenericSimpleButton text={textoEstado} buttonClass="btn btn-secondary" onClick={() => this.validateAddCard()}
                                    {...disabledBotonNuevaTarjetaProp} />
                            </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default InputComplete